import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  radioContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  radio: {
    height: 20,
    width: 20,
    borderRadius: 10,
  },
  dot: {
    height: 10,
    width: 10,
    borderRadius: 5,
  },
})
